"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImplementationRulesReviewResultSchema = exports.FilterMissSchema = exports.FilterMissRuleSchema = exports.ImplementationRulesReviewSummarySchema = exports.FormulaExcerptCountsSchema = exports.AiRuleCountsSchema = exports.KeptRuleCountsSchema = exports.SurfacedContentCountsSchema = exports.RuleAuthorSchema = exports.RuleAuthor = exports.ExcerptSkipReasonSchema = exports.ExcerptSkipReason = void 0;
const z = require("zod");
var ExcerptSkipReason;
(function (ExcerptSkipReason) {
    ExcerptSkipReason["ExcludedSection"] = "excluded_section";
    ExcerptSkipReason["NoNormativeWording"] = "no_normative_wording";
    ExcerptSkipReason["InsideTable"] = "inside_table";
    ExcerptSkipReason["InsideFigure"] = "inside_figure";
    ExcerptSkipReason["FigureCaptionNotMatched"] = "figure_caption_not_matched";
    ExcerptSkipReason["FormulaRejected"] = "formula_rejected";
    ExcerptSkipReason["AlreadyPackageData"] = "already_package_data";
    ExcerptSkipReason["EmptyText"] = "empty_text";
    ExcerptSkipReason["UnsupportedElementType"] = "unsupported_element_type";
    ExcerptSkipReason["NoElementCited"] = "no_element_cited";
    ExcerptSkipReason["ElementNotFound"] = "element_not_found";
    ExcerptSkipReason["OtherDocument"] = "other_document";
})(ExcerptSkipReason || (exports.ExcerptSkipReason = ExcerptSkipReason = {}));
exports.ExcerptSkipReasonSchema = z.nativeEnum(ExcerptSkipReason);
var RuleAuthor;
(function (RuleAuthor) {
    RuleAuthor["Ai"] = "ai";
    RuleAuthor["Reviewer"] = "reviewer";
})(RuleAuthor || (exports.RuleAuthor = RuleAuthor = {}));
exports.RuleAuthorSchema = z.nativeEnum(RuleAuthor);
exports.SurfacedContentCountsSchema = z.object({
    surfaced: z.number().int().nonnegative(),
    citedByKeptRule: z.number().int().nonnegative(),
    dismissed: z.number().int().nonnegative(),
});
exports.KeptRuleCountsSchema = z.object({
    kept: z.number().int().nonnegative(),
    filterReached: z.number().int().nonnegative(),
    filterMissed: z.number().int().nonnegative(),
});
exports.AiRuleCountsSchema = z.object({
    proposed: z.number().int().nonnegative(),
    confirmed: z.number().int().nonnegative(),
    edited: z.number().int().nonnegative(),
    rejected: z.number().int().nonnegative(),
    reviewerAdded: z.number().int().nonnegative(),
});
exports.FormulaExcerptCountsSchema = z.object({
    confirmed: z.number().int().nonnegative(),
    confirmedCitedByKeptRule: z.number().int().nonnegative(),
    uncertain: z.number().int().nonnegative(),
    uncertainCitedByKeptRule: z.number().int().nonnegative(),
    unclassified: z.number().int().nonnegative(),
    unclassifiedCitedByKeptRule: z.number().int().nonnegative(),
});
exports.ImplementationRulesReviewSummarySchema = z.object({
    content: exports.SurfacedContentCountsSchema,
    rules: exports.KeptRuleCountsSchema,
    ai: exports.AiRuleCountsSchema,
    formulas: exports.FormulaExcerptCountsSchema,
});
exports.FilterMissRuleSchema = z.object({
    id: z.string(),
    text: z.string(),
    authoredBy: exports.RuleAuthorSchema,
});
exports.FilterMissSchema = z.object({
    pageNumber: z.number().int().positive().nullable(),
    elementIndex: z.number().int().nonnegative().nullable(),
    rowIndex: z.number().int().nonnegative().nullable(),
    whyFilterSkipped: exports.ExcerptSkipReasonSchema,
    keptRules: exports.FilterMissRuleSchema.array(),
});
exports.ImplementationRulesReviewResultSchema = z.object({
    planId: z.string(),
    fragmentName: z.string(),
    packageId: z.string(),
    datasheetFileId: z.string(),
    excerptVersion: z.string(),
    completedByUserId: z.string().nullable(),
    summary: exports.ImplementationRulesReviewSummarySchema,
    filterMisses: exports.FilterMissSchema.array(),
});
//# sourceMappingURL=implementation-rules-review-result.types.js.map